export function useScrollToPageTop(): () => void {
  return () => {
    const mainEl = document.getElementsByTagName("main")[0];
    mainEl.scrollTo({ top: 0, behavior: "smooth" });
  };
}
